import Container from "@memorang/ui/src/components/Container";
import LeaderBoardApplet from "@memorang/ui/src/components/LeaderBoardApplet";
import Loader from "@memorang/ui/src/components/Loader";
import { useDevice } from "@memorang/ui/src/useDevice";
import { router } from "expo-router";
import { useTranslation } from "react-i18next";
import type { PeriodType } from "../api/queries";
/* -----------------Helpers & Hooks--------------- */
import useLeaderboard from "../hooks/useLeaderboard";
import useUserLeaderboard from "../hooks/useUserLeaderboard";
const LeaderboardContainer = () => {
	const {
		leaderboards,
		podiumData,
		selectedChip,
		handleSelectChip,
		fetchingLeaderboard,
	} = useLeaderboard();

	const { isMobile } = useDevice();
	const { userLeaderboardResponse } = useUserLeaderboard(selectedChip);
	const { t } = useTranslation();
	if (fetchingLeaderboard || !leaderboards || !userLeaderboardResponse) {
		return <Loader />;
	}
	return (
		<Container
			style={{
				paddingHorizontal: isMobile ? 0 : 16,
				paddingVertical: isMobile ? 0 : 16,
			}}
			// biome-ignore lint/a11y/useSemanticElements: <explanation>
			role="main"
		>
			<LeaderBoardApplet
				leaderboards={leaderboards}
				topRankers={podiumData}
				selectedChip={selectedChip}
				userLeaderboardItem={userLeaderboardResponse}
				handleSelectChip={(chip) => handleSelectChip(chip as PeriodType)}
				isVisibleLeaderBoardDataError={false}
				noLeaderboardDataMessage={t("emptyState.leaderboard.title")}
				noLeaderboardDataDopInfo={t("emptyState.leaderboard.subtitle")}
				noLeaderboardDataButtonText={"Study Now"}
				avatarType="identicon"
				handleEmptyStateCtaClick={() => {
					router.push("/home");
				}}
			/>
		</Container>
	);
};

export default LeaderboardContainer;
